import React from 'react';

import { createComponent } from '@lit/react';

const MdRipple = customElements.get("md-ripple");


export default createComponent({

    tagName: 'md-ripple',

    elementClass: MdRipple!,

    react: React,

    events: {

    },

});